import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import CommonFooter from "../../../components/footer/CommonFooter";
import CommonButton from "../../../components/button/CommonButton";
import { appApiHandler } from "../../../api/appApiHandler";
import "./ratingAndReview.css";
// import HomeHeader from "../../../components/header/HomeHeader";
import { showErrorToast } from "../../../utils/toast";
import { getErrorMessage } from "../../../constants/globalFunction";
import { string } from "../../../constants/string";
import Breadcrumb from "../../../components/breadcrumb";
import { useSelector } from "react-redux";

const RatingAndReview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderProductId, orderId, productDetails, fromNotification } =
    location.state;

  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { userData } = useSelector((state) => state.userState);

  const handleSubmit = async () => {
    if (!userData) {
      showErrorToast(string.error.please_login_to_your_account);
      return;
    }

    if (!rating && message.trim() === "") {
      setErrorMessage("Please provide either rating or review");
      return;
    }

    setErrorMessage("");
    setLoading(true);

    try {
      const reqData = {
        order_product_id: orderProductId,
        rating: rating,
        review: message,
      };

      const response = await appApiHandler.addReviewRating(reqData);

      if (response?.status === 200) {
        navigate("/order-details", {
          state: {
            orderId: orderId,
          },
          replace: true,
        });
      } else if (response?.message) {
        showErrorToast(getErrorMessage(response?.message));
      } else {
        showErrorToast(string.error.failed_due_to_internal_error);
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      showErrorToast(string.error.failed_due_to_internal_error);
    } finally {
      setLoading(false);
    }
  };

  const handleStarClick = (starValue) => {
    if (rating === starValue) {
      setRating(rating - 1);
    } else {
      setRating(starValue);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="rating-review-page">
      {/* <HomeHeader /> */}
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          ...(fromNotification
            ? [
                {
                  label: "Notifications",
                  path: "/notifications",
                },
                {
                  label: "Order Details",
                  path: "/order-details",
                  onClick: () =>
                    navigate("/order-details", {
                      state: {
                        orderId: orderId,
                        fromNotification: true,
                      },
                    }),
                },
              ]
            : [
                {
                  label: "My Order",
                  path: "/orders",
                },
                {
                  label: "Order Details",
                  path: "/order-details",
                  onClick: () =>
                    navigate("/order-details", {
                      state: {
                        orderId: orderId,
                      },
                    }),
                },
              ]),
          {
            label: "Review and Rating",
            isActive: true,
          },
        ]}
      />
      <div className="rating-review-container">
        <div className="rating-review-card">
          <h2 className="rating-review-title">Review and Rating</h2>

          {productDetails && (
            <div className="product-summary">
              <div className="product-summary__image">
                {productDetails.image ? (
                  <img
                    src={productDetails.image}
                    alt={productDetails.name}
                    className="product-summary__img"
                    loading="lazy"
                  />
                ) : (
                  <div className="product-summary__placeholder" />
                )}
              </div>
              <div className="product-summary__details">
                <h3 className="product-summary__name">{productDetails.name}</h3>
              </div>
            </div>
          )}

          <div className="rating-section">
            <h3 className="rating-section__title">Rating</h3>
            <div className="rating-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  onClick={() => handleStarClick(star)}
                  className="rating-star-btn"
                  type="button"
                >
                  <FaStar
                    className={`rating-star ${
                      star <= rating ? "rating-star--filled" : ""
                    }`}
                  />
                </button>
              ))}
            </div>
          </div>

          <div className="review-section">
            <h3 className="review-section__title">Review</h3>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Share your experience with this product..."
              className="review-textarea"
              maxLength={180}
              rows={6}
            />
            <div className="review-character-count">
              {message.length}/180 characters
            </div>
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="rating-review-actions">
            <CommonButton
              title="Cancel"
              onPress={handleCancel}
              outlined={true}
              customClassName="rating-review-btn--cancel"
            />
            <CommonButton
              title={loading ? "Submitting..." : "Submit"}
              onPress={handleSubmit}
              disabled={loading}
              customClassName="rating-review-btn--submit"
            />
          </div>
        </div>
      </div>
      <CommonFooter />
    </div>
  );
};

export default RatingAndReview;
